import { z } from "zod"

import { entityIdSchema } from "./identifiers.js"

const instantSchema = z.iso.datetime({ offset: true })

export const workShiftStateV1Schema = z.enum(["Active", "On Break", "Ended"])

export const workShiftStartV1Schema = z.object({
  workShiftId: entityIdSchema,
  workerId: entityIdSchema,
  relationshipId: entityIdSchema,
  eventId: entityIdSchema,
  capturedAt: instantSchema,
  effectiveAt: instantSchema,
}).strict().refine((value) => value.capturedAt >= value.effectiveAt, {
  path: ["capturedAt"],
  message: "Capture time cannot precede effective time.",
})

export const workShiftEventV1Schema = z.object({
  eventId: entityIdSchema,
  capturedAt: instantSchema,
  effectiveAt: instantSchema,
}).strict().refine((value) => value.capturedAt >= value.effectiveAt, {
  path: ["capturedAt"],
  message: "Capture time cannot precede effective time.",
})

export const workShiftBranchAllocationV1Schema = z.object({
  eventId: entityIdSchema,
  attributionBranchId: entityIdSchema,
  capturedAt: instantSchema,
  effectiveAt: instantSchema,
}).strict().refine((value) => value.capturedAt >= value.effectiveAt, {
  path: ["capturedAt"],
  message: "Capture time cannot precede effective time.",
})

export const timeCorrectionRequestV1Schema = z.object({
  correctionId: entityIdSchema,
  workShiftId: entityIdSchema,
  targetEventId: entityIdSchema,
  proposedEffectiveAt: instantSchema,
  reason: z.string().trim().min(1).max(2_000),
}).strict()

export const timeCorrectionReviewV1Schema = z.object({
  decision: z.enum(["approve", "reject"]),
  reason: z.string().trim().min(1).max(2_000),
}).strict()

export const workShiftResultV1Schema = z.object({
  entityType: z.enum(["work_shift", "time_correction"]),
  entityId: entityIdSchema,
  state: z.string().min(1).max(80),
  version: z.number().int().nonnegative(),
  workerId: entityIdSchema,
  relationshipId: entityIdSchema,
  legalEntityId: entityIdSchema,
  startingBranchId: entityIdSchema,
  eventId: entityIdSchema.nullable(),
  attributionBranchId: entityIdSchema.nullable(),
  correctedEventId: entityIdSchema.nullable(),
}).strict()

export type WorkShiftStartV1 = z.infer<typeof workShiftStartV1Schema>
export type WorkShiftEventV1 = z.infer<typeof workShiftEventV1Schema>
export type WorkShiftBranchAllocationV1 = z.infer<
  typeof workShiftBranchAllocationV1Schema
>
export type TimeCorrectionRequestV1 = z.infer<typeof timeCorrectionRequestV1Schema>
export type TimeCorrectionReviewV1 = z.infer<typeof timeCorrectionReviewV1Schema>
export type WorkShiftResultV1 = z.infer<typeof workShiftResultV1Schema>
